import { format } from 'date-fns/esm';
import Base from './Base';

export default class Statement extends Base {
  id: number;
  month: number;
  year: number;
  areaId: number;
  ownerId: number;
  expenseAmount: string;
  grossAmount: string;
  netAmount: string;
  s3key: string;
  statementType: string;

  constructor(data: any) {
    super();
    this.id = data.id;
    this.month = data.month;
    this.year = data.year;
    this.areaId = data.areaId;
    this.ownerId = data.ownerId;
    this.expenseAmount = data.expenseAmount;
    this.grossAmount = data.grossAmount;
    this.netAmount = data.netAmount;
    this.s3key = data.s3key;
    this.statementType = data.statementType;
  }

  static parseFromData(data: any): Statement {
    return new Statement({
      id: data.id,
      month: data.month,
      year: data.year,
      areaId: data.area_id,
      ownerId: data.owner_id,
      expenseAmount: data.expense_amount,
      grossAmount: data.gross_amount,
      netAmount: data.net_amount,
      s3key: data.s3key,
      statementType: data.statement_type,
    });
  }

  getStatementDate(): string {
    if (!this.year || !this.month) {
      return '';
    }
    if (this.statementType === 'month') {
      const date = new Date();
      date.setDate(1);
      date.setFullYear(this.year);
      date.setMonth(this.month - 1);

      return format(date, 'MMM yyyy');
    } else {
      return 'Annual FY ' + (this.year - 1) + '/' + this.year;
    }
  }
}
